import { InteractionsLogger } from './interactionsLogger';
import { InteractionsLoggerV1 } from './interactionsLoggerV1';
import { InteractionsLoggerV2 } from './interactionsLoggerV2';
import {
    EventInteraction,
    EventInteractionContext,
    EventInteractions,
    InteractionCustomEvent,
    PLACE_EVENT_INTERACTION,
} from './types';

export class EventsInteractionsTracker {
    private LOG_PERIODICITY_MILLISECONS = 5000;
    private interactionsLoggers: InteractionsLogger[];
    private interactions: EventInteraction<EventInteractionContext>[] = [];
    private interactions_history: Set<string> = new Set();
    private element: Subscribable;
    private setInterval: (callback: () => void, milliseconds: number) => void;

    constructor(
        element: Subscribable,
        interactionsLoggers = [
            new InteractionsLoggerV1(),
            new InteractionsLoggerV2(),
        ],
        setInterval = window.setInterval,
    ) {
        this.element = element;
        this.interactionsLoggers = interactionsLoggers;
        this.setInterval = setInterval;
    }

    listen() {
        this.element.addEventListener(PLACE_EVENT_INTERACTION, ({ detail }) => {
            const interactionUniqueId = `${detail.id}-${detail.place?.placementId}-${detail.action}`;

            if (
                detail.action == EventInteractions.Impression &&
                this.interactions_history.has(interactionUniqueId)
            ) {
                return;
            }

            this.interactions_history.add(interactionUniqueId);
            this.interactions.push(detail);
        });
    }

    track() {
        this.setInterval.call(
            window,
            () => {
                this.logStoredInteractions();
            },
            this.LOG_PERIODICITY_MILLISECONS,
        );

        this.element.addEventListener('beforeunload', () =>
            this.logStoredInteractions(),
        );
    }

    private logStoredInteractions() {
        const logsLimit = 10;
        for (let i = 0; i < this.interactions.length; i += logsLimit) {
            const logsBlock = this.interactions.slice(i, i + logsLimit);
            this.interactionsLoggers.forEach((il) => {
                il.log(logsBlock);
            });
        }
        this.interactions = [];
    }
}

export interface Subscribable {
    addEventListener(
        type: string,
        listener: (
            event: InteractionCustomEvent<EventInteractionContext>,
        ) => void,
    ): void;
}
